import {createStore, applyMiddleware} from "redux";

import rootReducer from "@reducers/index";

import {composeWithDevTools} from 'redux-devtools-extension';

import ReduxThunk from 'redux-thunk';
import progressMiddleware from "@/middleware/progressMiddleware";



const store = createStore(rootReducer, composeWithDevTools(

    applyMiddleware(ReduxThunk, progressMiddleware),

));



export default store;

